export var baseStyle = {
  button: {
    fontWeight: 'bold',
    _focus: {
      bg: 'yellow.200',
      color: 'grey.970'
    }
  }
};
export default {
  baseStyle
};